import { render, staticRenderFns } from "./MainAddress.vue?vue&type=template&id=ec9573b0&scoped=true"
import script from "./MainAddress.vue?vue&type=script&lang=js"
export * from "./MainAddress.vue?vue&type=script&lang=js"
import style0 from "./MainAddress.vue?vue&type=style&index=0&id=ec9573b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9573b0",
  null
  
)

export default component.exports